import {_, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource} from '@api'
import {useWhiteboardStore} from '@modules/whiteboard'
import * as css from './CurrentToolPanel.css'

export const CurrentToolPanel = observer<{className?: string}>(function CurrentToolPanel({className}) {
    const {appState: {activeTool}} = useWhiteboardStore()

    return (<div className={classNames(css.root, className)} data-tool={activeTool}>
        {/*{activeTool}*/}
    </div>)
})


// WEBPACK FOOTER //
// ./src/modules/whiteboard/components/CurrentToolPanel/CurrentToolPanel.tsx